<template>
  <v-menu :disabled="!networkChangeAllowed">
    <template #activator="{ props, isActive }">
      <a
        v-bind="props"
        variant="text"
        class="active-network bcl-app-header-options d-flex align-center px-1 px-lg-3"
        :title="$t('common.network')"
        :readonly="!networkChangeAllowed"
      >
        <v-icon color="green" size="14" icon="mdi-circle" />
        <span class="d-lg-block ml-2">{{ activeNetwork.name }}</span>
        <v-icon
          v-if="networkChangeAllowed"
          class="mr-n1"
          :icon="isActive ? 'mdi-chevron-up' : 'mdi-chevron-down'"
        />
      </a>
    </template>
    <v-list>
      <template v-for="network in NETWORKS" :key="network.networkId">
        <v-list-item
          v-if="network.networkId !== activeNetwork.networkId"
          :value="network.networkId"
          @click="changeActiveNetwork(network.networkId)"
        >
          <v-list-item-title>
            {{ network.name }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script lang="ts" setup>
import { defineProps } from "vue";
import { useNetwork } from "@/composables";
import { NETWORKS } from "@/utils/constants";

defineProps({
  dense: Boolean,
});

const { activeNetwork, changeActiveNetwork } = useNetwork();

const networkChangeAllowed = Object.keys(NETWORKS).length > 1;
</script>

<style lang="scss" scoped>
.active-network {
  cursor: pointer;
}
</style>
